module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/mobile-app-redirect/mobile-app-redirect.component.css
// module id = ./src/app/devotee/mobile-app-redirect/mobile-app-redirect.component.css
// module chunks = main